import { memo, ReactElement } from 'react';
import { Button } from '@/common/ui';
import * as S from './VActivityDetail.styles';
import { ActivityDescription } from '@/screens/ActivityPage/ui/ActivityDetail/ActivityDescription/ActivityDescription';
import { LowestPrice } from '@/shared/images/icons/LowestPrice';
import { Cancellation } from '@/shared/images/icons/Cancellation';
import { Confidence } from '@/shared/images/icons/Confidence';
import { ImagesGallery } from '@/screens/ActivityPage/ui/ActivityDetail/ImagesGallery/ImagesGallery';
import {
    GalleryWrapper,
    Price,
} from '@/screens/ActivityPage/ui/ActivityDetail/ActivityDetail.styles';
import { TImageItem } from '@/common/service/api/Activity/Activity.domain';
import { getNormalisedPrice } from '@/common/app/utils/getNormalisedPrice';

type VActivityDetailProps = {
    images: TImageItem[];
    productUrl: string;
    price: number;
    currency: string;
    onBookNow?: () => void;
};

const VActivityDetailContainer = ({
    images,
    productUrl,
    onBookNow,
    price,
    currency,
}: VActivityDetailProps): ReactElement => {
    const priceWithComma = getNormalisedPrice(price, currency);
    const defaultOnBookNow = () => {
        if (typeof window !== 'undefined') {
            window.open(productUrl, '_blank', 'noopener,noreferrer');
        }
    };

    const bookNowHandler = onBookNow || defaultOnBookNow;

    return (
        <S.VContainer data-test-id="VActivityDetail">
            <GalleryWrapper>
                <ImagesGallery
                    userImages={images}
                    activityId={''}
                    activitySlug={''}
                    videos={[]}
                    eagerMore
                    type="landmark_photo"
                />
            </GalleryWrapper>
            <S.VInfoContainer>
                <S.PriceContainer>
                    {priceWithComma ? (
                        <>
                            From&nbsp; &nbsp;
                            <Price>{priceWithComma}</Price>
                        </>
                    ) : (
                        <Price>Price varies</Price>
                    )}
                </S.PriceContainer>
                <S.VBookNowButtonContainer>
                    <Button variant="primary" onClick={bookNowHandler} data-test-id="VBook_now_btn">
                        Check Rates & Availability
                    </Button>
                </S.VBookNowButtonContainer>
                <S.VDivider />
                <S.VDescriptionContainer>
                    <ActivityDescription
                        icon={<LowestPrice />}
                        title="Instant Confirmation"
                        description="Secure your spot in seconds"
                    />
                    <ActivityDescription
                        icon={<Confidence />}
                        title="Book in Minutes"
                        description="Fast and easy online checkout"
                    />
                    <ActivityDescription
                        icon={<Cancellation />}
                        title="Reserve with Confidence"
                        description="Trusted by thousands of travelers"
                    />
                </S.VDescriptionContainer>
            </S.VInfoContainer>
        </S.VContainer>
    );
};

export const VActivityDetail = memo(VActivityDetailContainer);
